import React from 'react';

/**
 * A HOC for periodically refreshing the wrapped component
 * @param WrappedComponent
 * @param interval time in milliseconds between refreshes
 * @returns {React.Component}
 */
export default function refresh(WrappedComponent, interval) {

  return class extends React.Component {
    constructor(props) {
      super(props);
      const intervalID = setInterval(() => {
        this.setState({ timestamp: Date.now() });
      }, interval);
      this.state = { timestamp: 0, intervalID };
    }

    componentWillUnmount() {
      clearInterval(this.state.intervalID);
    }

    render() {
      return <WrappedComponent {...this.props} refreshTimestamp={this.state.timestamp} />;
    }
  };
}
